import moment from 'moment';
import React, { FC } from 'react';
import { Content } from '../../components/content';
import { Header } from '../../components/header/header';
import { Page } from '../../components/page';
import { URL_DATE_FORMAT } from '../../constants/dates';
import { SHIP_TO_ID_PARAM } from '../../constants/routes';
import { IOrder, IShipTo, ISoldTo, Status } from '../../graphql/types';
import { OrdersBody } from './body';
import { GetOrdersByDateQuery } from './queries/orders-by-date';
import { ORDERS_PAGE_ROUTE } from './route';
import { SoldToTopSection } from './top-section';

export const START_DATE_PARAM = 'start';
export const END_DATE_PARAM = 'end';

export interface IOrdersByDateRange {
  [SHIP_TO_ID_PARAM]?: string;
  status?: string;
  vessel?: string;
  [START_DATE_PARAM]: string;
  [END_DATE_PARAM]: string;
}

interface IOrdersByDateRangeProps extends Omit<IOrdersByDateRange, 'status'> {
  soldToId: string;
  statuses: Status[];
  vesseles: string[];
}

export const OrdersByDateRangePage: FC<IOrdersByDateRangeProps> = ({
  soldToId,
  end,
  shipToId,
  start,
  statuses,
  vesseles,
}) => {
  const endDate = moment(end, URL_DATE_FORMAT);
  const startDate = moment(start, URL_DATE_FORMAT);

  return (
    <Page
      data-type="page"
      data-page={ORDERS_PAGE_ROUTE}
      data-sold-to-id={soldToId}
      data-start={start}
      data-end={end}
      data-ship-to-id={shipToId}
    >
      <Header />
      <Content>
        <GetOrdersByDateQuery
          endDate={endDate}
          shipToId={shipToId}
          soldToId={soldToId}
          startDate={startDate}
          render={(
            orders: IOrder[],
            soldTo: ISoldTo | null,
            shipTo?: IShipTo
          ) => {
            return (
              <>
                {soldTo && <SoldToTopSection soldTo={soldTo} shipTo={shipTo} />}
                <OrdersBody
                  soldToId={soldToId}
                  shipToId={shipToId}
                  orders={orders}
                  startDate={startDate}
                  endDate={endDate}
                  statuses={statuses}
                  showDatePill={true}
                  vesseles={vesseles}
                />
              </>
            );
          }}
        />
      </Content>
    </Page>
  );
};
